import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareArrowBottomRightCorner: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSquareArrowBottomRightCorner"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM9.93945 11L14.4395 15.5H11V17H17V11H15.5V14.4395L11 9.93945L9.93945 11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareArrowBottomRightCorner;
